import { BankAccountDetailsAddModel } from '@/legacy/viewmodels/addModels';

interface SecondaryBankValidBankAccountViewModel {
  maskedAccountNumber: string;
  accountOperatingName: string;
  hasAccountHolderName: boolean;
  isBankingDetailsValid: boolean;
  country: string;
  currency: string;
}

export class SecondaryBankAccountDetailsAddModel extends BankAccountDetailsAddModel {
  public loginId: string;

  public relatedId: string;

  public requestId: string;

  public accountId: string;

  public institution: string;

  public account: SecondaryBankValidBankAccountViewModel;
}
